import { generatePath, useHistory } from 'react-router-dom'
import {
  useNetworkHomeJobsRouteParams,
  useCurrentHomeSiteId,
  useNetworkOrgId,
} from 'features/networkAi/hooks'
import ROUTES from 'app/routes'
import { useIntl } from 'react-intl'
import { makePublicUrl } from 'app/utils/publicUrl'
import { H2 } from 'components/Typography'
//import { WhiteBlock } from 'components/Layout'
import { StyledFadeInWrapper } from 'components/Layout/CommonLayout/styles'
import {
  NetworkAPContainer,
  NetworkAPHeader,
  NavigateToMistButton,
  NavigateToMistForwardIcon,
  HomeConfigurationWhiteBlock,
} from './styles'
import { NetworkAIBackButton, NetworkAIBackIcon } from '../styles'
import { network } from 'features/networkAi/messages'
import APListView from './APListView'
import { MIST_CLOUD_URL } from 'app/consts'

function NetworkAccessPoints() {
  const { formatMessage } = useIntl()
  const history = useHistory()
  const { rootDomainId, homeId, jobId } = useNetworkHomeJobsRouteParams()
  const siteId = useCurrentHomeSiteId({ homeId })
  const orgId = useNetworkOrgId()

  function MistUrl() {
    const url = `${MIST_CLOUD_URL}/admin/?org_id=${orgId}#!ap/${siteId}`
    return url
  }

  const handleNavigateNetworkAIClick = () => {
    const pathname = generatePath(ROUTES.networkAi.dashboard.root, {
      rootDomainId,
      jobId,
      homeId,
      siteId,
    })
    history.push(pathname)
  }

  return (
    <StyledFadeInWrapper>
      <NetworkAPContainer>
        <NetworkAIBackButton onClick={handleNavigateNetworkAIClick}>
          <NetworkAIBackIcon
            src={makePublicUrl(`images/networkIcons/arrow-back.svg`)}
          />
          {formatMessage(network.backNetworkAI)}
        </NetworkAIBackButton>

        <NetworkAPHeader>
          <H2>{formatMessage(network.accessPoints)}</H2>
        </NetworkAPHeader>

        <HomeConfigurationWhiteBlock>
          <NavigateToMistButton as="a" href={MistUrl()} target="_blank">
            <NavigateToMistForwardIcon
              src={makePublicUrl(`images/networkIcons/arrow-forward.svg`)}
            />
          </NavigateToMistButton>
          <APListView siteId={siteId} />
        </HomeConfigurationWhiteBlock>
      </NetworkAPContainer>
    </StyledFadeInWrapper>
  )
}

export default NetworkAccessPoints
